import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["suggested", "unassigned", "assigned", "suggestedTab", "unassignedTab", "assignedTab", "submitButton"]

  connect() {
    if (this.suggestedTargets.length > 0) {
      this.submitButtonTargets.forEach(submit => submit.disabled = false)
      this.showSuggested()
      this.suggestedTabTarget.classList.add("active")
    }
    else if (this.unassignedTargets.length > 0) {
      this.showUnassigned()
      this.unassignedTabTarget.classList.add("active")
    }
    else {
      this.showAssigned()
      this.assignedTabTarget.classList.add("active")
    }
  }

  showSuggested() {
    this.hideItems(this.unassignedTargets)
    this.hideItems(this.assignedTargets)
    this.showItems(this.suggestedTargets)
    this.triggerSearch()
  }

  showAssigned() {
    this.hideItems(this.unassignedTargets)
    this.hideItems(this.suggestedTargets)
    this.showItems(this.assignedTargets)
    this.triggerSearch()
  }

  showUnassigned() {
    this.hideItems(this.assignedTargets)
    this.hideItems(this.suggestedTargets)
    this.showItems(this.unassignedTargets)
    this.triggerSearch()
  }

  hideItems(items) {
    items.forEach(item => {
      item.classList.add("hidden")
      item.classList.remove("tabFiltered")
    })
  }

  showItems(items) {
    items.forEach(item => {
      item.classList.remove("hidden")
      item.classList.add("tabFiltered")
    })
  }

  triggerSearch() {
    const event = new CustomEvent("airbnb:apply-search")

    window.dispatchEvent(event)
  }

  enableSubmitButton() {
    this.submitButtonTargets.forEach(submit => submit.disabled = false)
  }
}
